import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { reduxForm, initialize, destroy } from 'redux-form'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { CheckboxField } from 'components/forms'
import { Button } from 'components/util'
import styles from './_consentsEditContent.css'
import { Title, SectionContent, PrivacyWrapper, FinePrint } from '../util'
import * as bootupSelectors from 'services/bootup/selectors'
import * as consents from 'services/consents/selectors'
import { selectSite } from 'services/site/selectors'
import { changeBulk } from 'shared/actions'

export const FORM_NAME = 'ConsentsEditContent'

const validate = () => {
  const errors = {}
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
  consentsList: consents.selectAcceptedConsents(state),
  site: selectSite(state),
})

const mapDispatchToActions = {
  initialize,
  destroy,
  changeBulk,
}

export class ConsentsEditContent extends Component {

  static propTypes = {
    accountPortalRoot: PropTypes.string,
    intl: PropTypes.object,
    consentsList: PropTypes.object,
    changeBulk: PropTypes.func,
    handleSubmit: PropTypes.func,
    site: PropTypes.object,
  }

  state = {
    unconsentsList: [],
  }

  componentWillMount () {
    const { consentsList: { acceptedContent }} = this.props
    const initialData = acceptedContent
      ? acceptedContent.reduce((result, item) => ({ ...result, [item.id]: true }), {})
      : {}
    this.props.changeBulk(FORM_NAME, initialData)
  }

  renderConsentItem (item) {
    return (
      <div>
        <h1>{item.title}</h1>
        <p>{item.contentSummary}</p>
        <a href={item.contentUrl} target='_blank' rel='noopener noreferrer'>
          <FormattedMessage
            id='privacy_center.consents.consentseditcontent.learnmore'
            defaultMessage='Learn More'
          />
        </a>
      </div>
    )
  }

  handleUnselectConsent = (evt) => {
    const value = evt.target.value
    const name = evt.target.name
    let { unconsentsList } = this.state
    if (value) {
      unconsentsList.push(name)
    } else {
      unconsentsList = unconsentsList.filter(item => item !== name)
    }
    this.setState({
      unconsentsList,
    })
  }

  render () {
    const { accountPortalRoot, consentsList, handleSubmit, site } = this.props
    const { unconsentsList } = this.state
    const appName = site.name || 'MapMyRun'
    const termsLink = `${accountPortalRoot}/terms-and-conditions`
    const privacyLink = `${accountPortalRoot}/privacy`
    const affiliatesLink = `${accountPortalRoot}/privacy#who-we-are`

    return (
      <form method='post' onSubmit={handleSubmit}>
        <PrivacyWrapper>
          <Title>
            <FormattedMessage
              id='privacy_center.consents.consentseditcontent.headerinfo'
              defaultMessage='Keep Your Data Safe'
            />
          </Title>
          <SectionContent>
            <FormattedMessage
              id='privacy_center.consents.consentseditcontent.withdraw'
              defaultMessage='You have agreed to the following consents which are required in order to use { appName }. To remove your consent from any of these policies, you will need to delete your account. '
              values={ { appName } }
            />
          </SectionContent>
          <div>
            {
              consentsList.acceptedContent ? consentsList.acceptedContent.map(item => {
                return (
                  <div key={item.id}>
                    <hr className={styles.consentHr} />
                    <CheckboxField
                      name={item.id}
                      className={styles.consentCheckboxField}
                      labelComponent={this.renderConsentItem(item)}
                      inputIconContainerClassName={styles.checkboxFieldIconContainer}
                      onChange={this.handleUnselectConsent}
                    />
                  </div>
                )
              }) : null
            }
          </div>
          <div className={styles.consentAffiliates}>
            <FormattedHTMLMessage
              id='privacy_center.terms.ua_affiliates'
              defaultMessage={'About <a href="{ affiliatesLink }" target="_blank">Under Armour, Inc. and its affiliates</a>.'}
              values={ {
                affiliatesLink,
              } }
            />
          </div>
          <hr />
          <div className={styles.consentfooter}>
            <FinePrint>
              <FormattedHTMLMessage
                id='privacy_center.privacy_and_terms'
                defaultMessage={'<a href="{ privacyLink }" target="_blank">Privacy Policy</a> & <a href="{ termsLink }" target="_blank">Terms of Use</a>.'}
                values={ {
                  termsLink,
                  privacyLink,
                } }
              />
            </FinePrint>
            { unconsentsList.length > 0 ? <div>
              <strong className={styles.consentRemoveWarning}>
                <FormattedMessage
                  id='privacy_center.consents.consentseditcontent.removeConsents'
                  defaultMessage='Removing consent will require you to delete your account.'
                />
              </strong>
              <Button
                el='button'
                type={'danger'}
                size='xlarge'
                className={styles.consentButton}>
                <FormattedMessage
                  id='privacy_center.consents.consentseditcontent.saveconsents'
                  defaultMessage='Save'
                />
              </Button>
            </div> : null }
          </div>
        </PrivacyWrapper>
      </form>
    )
  }
}

export const Form = reduxForm(formOptions)(ConsentsEditContent)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(Form)
